import React, { Component } from "react";
import TrickOrTreat from "./TrickOrTreat";
import Share from "./Share";
import { Bat, LittlePumpkin, SpookyTree } from "./Art";
import { HalloweenState, closing, fetchHalloween, trackHalloween } from "./api";

// /halloween: the same game as the pop-up, on a page of its own so it can be
// shared, emailed and posted.

// More bats in the empty space either side of the game on a wide screen.
// Hidden on phones, where there is no empty space.
const MORE_BATS = [
  { side: "left", across: 8, down: 210, size: 58, delay: 0.2 },
  { side: "left", across: 20, down: 150, size: 34, delay: 0.9 },
  { side: "left", across: 15, down: 330, size: 42, delay: 0.5 },
  { side: "left", across: 5, down: 440, size: 30, delay: 1.1 },
  { side: "right", across: 7, down: 260, size: 54, delay: 0.7 },
  { side: "right", across: 19, down: 180, size: 36, delay: 0.1 },
  { side: "right", across: 13, down: 380, size: 32, delay: 0.4 },
  { side: "right", across: 23, down: 470, size: 26, delay: 1.3 },
];

interface State {
  halloween?: HalloweenState;
  failed: boolean;
  // Once they have played, the prize carries its own share buttons.
  played: boolean;
}

class HalloweenPage extends Component<{}, State> {
  state: State = { failed: false, played: false };

  componentDidMount() {
    fetchHalloween()
      .then((halloween) => {
        this.setState({ halloween });
        trackHalloween("open", { trigger: "page" });
      })
      .catch(() => this.setState({ failed: true }));
  }

  render() {
    const { halloween, failed } = this.state;
    const ends = closing(halloween?.ends_at ?? null);

    return (
      <main className="hw-page">
        <svg className="hw-page__bats" viewBox="0 0 1200 160" aria-hidden="true" preserveAspectRatio="xMidYMin slice">
          <Bat x={120} y={60} scale={1.6} />
          <Bat x={980} y={40} scale={1.3} delay={0.4} />
          <Bat x={1080} y={110} scale={1} delay={0.8} />
        </svg>
        <div className="hw-page__scenery" aria-hidden="true">
          {MORE_BATS.map((bat) => (
            <svg
              key={`${bat.side}-${bat.down}`}
              className="hw-page__bat"
              viewBox="0 0 26 12"
              style={{ [bat.side]: `${bat.across}%`, top: bat.down, width: bat.size, animationDelay: `${-bat.delay * 4}s` }}
            >
              <Bat x={0} y={0} delay={bat.delay} />
            </svg>
          ))}
          <svg className="hw-page__ground" viewBox="0 0 1440 40" preserveAspectRatio="none">
            <path d="M0 20c240-8 480-12 720-6s480 8 720-2v28H0z" fill="#07050a" />
          </svg>
          <svg className="hw-page__woods hw-page__woods--left" viewBox="0 0 440 380" preserveAspectRatio="xMinYMax meet">
            <SpookyTree seed={7} x={130} y={372} scale={1.15} />
            <SpookyTree seed={23} x={300} y={376} scale={0.62} />
            <path d="M0 360c80-22 190-26 300-8 60 10 110 16 140 14v14H0z" fill="#07050a" />
            <g transform="translate(206 336) scale(.62)">
              <LittlePumpkin />
            </g>
          </svg>
          <svg className="hw-page__woods hw-page__woods--right" viewBox="0 0 440 380" preserveAspectRatio="xMaxYMax meet">
            <SpookyTree seed={41} x={320} y={374} scale={1.2} />
            <SpookyTree seed={95} x={150} y={376} scale={0.7} />
            <path d="M440 358c-80-22-200-24-310-6-60 10-100 14-130 14v14h440z" fill="#07050a" />
          </svg>
        </div>
        <div className="hw-page__inner">
          {halloween && (
            <TrickOrTreat halloween={halloween} variant="page" onPlayed={(play) => this.setState({ played: !!play })} />
          )}
          {!halloween && !failed && <div className="hw-page__loading">Stirring the cauldron…</div>}
          {failed && (
            <div className="hw-page__loading">
              The cauldron hiccupped. <a href="/halloween">Try again</a>?
            </div>
          )}
          {halloween && halloween.running && !halloween.play && !this.state.played && (
            <div className="hw-page__share">
              <Share heading="Not playing? Send it to someone who will." />
            </div>
          )}
          <p className="hw-page__rules">
            One go per person. Each code works once, on any course or the Pass
            {ends && `, and stops working at ${ends.time} UK time on ${ends.weekday} ${ends.date}`}. The tips booklets
            are PDFs from our courses.
          </p>
        </div>
      </main>
    );
  }
}

export default HalloweenPage;
